import {
  consumeCanvasCaptureAccessTokenFromUrl,
  consumeCanvasCaptureInjectedAccessToken,
} from "./canvasCaptureAccessToken";

/**
 * Short-lived API JWT for `canvas-capture.html`: Lambda-injected global, or one-time
 * `?capture_access_token=` (see `canvasCaptureAccessToken.ts`). Used by the shared axios
 * getter while capture JWT is active.
 */
let canvasCaptureBearerToken: string | null = null;

/** Token came from Puppeteer `evaluateOnNewDocument` (production hero capture). */
let lambdaInjectedCanvasCaptureAuth = false;

/** Token came from query string (local dev / `scripts/build-canvas-capture-url.mjs`). */
let urlSuppliedCanvasCaptureAuth = false;

const injectedOnLoad = consumeCanvasCaptureInjectedAccessToken();
const urlAccessToken = consumeCanvasCaptureAccessTokenFromUrl();
if (injectedOnLoad) {
  canvasCaptureBearerToken = injectedOnLoad;
  lambdaInjectedCanvasCaptureAuth = true;
} else if (urlAccessToken) {
  canvasCaptureBearerToken = urlAccessToken;
  urlSuppliedCanvasCaptureAuth = true;
}

/** Do not clear bearer on capture-app unmount (StrictMode-safe; token not re-readable from URL/global). */
export function retainCanvasCaptureBearerOnUnmount(): boolean {
  return lambdaInjectedCanvasCaptureAuth || urlSuppliedCanvasCaptureAuth;
}

export function clearCanvasCaptureBearerToken() {
  canvasCaptureBearerToken = null;
}

export function getCanvasCaptureBearerToken(): string | null {
  return canvasCaptureBearerToken;
}
